module.exports = __webpack_public_path__ + "static/media/workfluxLogo.501d3d6d.png";